var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3739 10.0404C23.7645 9.64992 23.7645 9.01675 23.3739 8.62623C22.9834 8.2357 22.3502 8.2357 21.9597 8.62623L16.0002 14.5858L10.0406 8.62623C9.65008 8.2357 9.01691 8.2357 8.62639 8.62623C8.23587 9.01675 8.23587 9.64992 8.62639 10.0404L14.5859 16L8.62639 21.9596C8.23587 22.3501 8.23587 22.9833 8.62639 23.3738C9.01691 23.7643 9.65008 23.7643 10.0406 23.3738L16.0002 17.4142L21.9597 23.3738C22.3502 23.7643 22.9834 23.7643 23.3739 23.3738C23.7645 22.9833 23.7645 22.3501 23.3739 21.9596L17.4144 16L23.3739 10.0404Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.479582f8d298b3985f50303481d89242.svg";
export { ForwardRef as ReactComponent };